module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAAXNSR0IArs4c6QAAAP1JREFUKBWNk7GuQUEQhq1oRQRRqGg9gc4zKDWioNFo7wvcRC9eQCE6iTitwkvQipAIDRGJwrnfrMnJuZJd/uTPzOz/z85uzh6TAGEYVggtmJXagw3a2BhzkaYmfMJvccVYSrFDHxrPlAfaAq5hDdZhVyb6cELMYbQg76k5kIk+TLnPGXMZUwfKRItPjUv1tYk/mtuQjBexfEe+gkdd22u91dp+Cj32vzCIDLEEx0hdgWtiHkMVpqWPWJSaVPgCCz40xIVh8GZyTtRt3UGOenfLTuUujROn7BYm0vgL5/Dp9kXKhWwIZ9Eb5fIFFjKR5ZUceDk3NHl28ufYWqQ/i+ftjL3ER1sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-facebook.png
// module id = 527
// module chunks = 0